import { useState } from 'react'
import * as Sentry from '@sentry/react'

const useApi = () => {
  const [bearerToken, setBearerToken] = useState<string>('')
  const [xAgency, setXAgency] = useState<string>('')

  const ALTO = 'ALTO';
  const GLUEDOG = 'GLUEDOG';
  const apiPath = process.env.REACT_APP_PP_API_URL

  const makeRequest = async (url: string, method: string = 'POST', body: object | null = null) => {
    const fullUrl = apiPath + '/' + url

    const options: RequestInit = {
      method: method,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
        'X-Prospector-Agency': xAgency,
      },
    }

    if (body && method !== 'GET' && method !== 'HEAD') {
      options.body = JSON.stringify(body)
    }

    const response = await fetch(fullUrl, options)

    if (!response.ok && response.status !== 404) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  }
  const createSessionRequest = async (crmKey: string, endpoint: string, crm: string, destination: string, leadCategory: string, callTriggerUrl: string) => {
    try {
      const url = crm === ALTO ? 'alto/start-call' : 'gluedog/start-call';
      return makeRequest(url, 'POST', {
        crm_key: crmKey,
        endpoint: endpoint,
        module: crm === ALTO ? ALTO: GLUEDOG,
        crm: crm,
        destination: destination,
        lead_category: leadCategory,
        call_trigger_url: callTriggerUrl
      })
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          message: 'makeRequest Failed',
          crmKey: crmKey ?? '',
          crm: crm ?? '',
          destination: destination ?? '',
        },
      })
      return null // Handle failure gracefully
    }
  }

  return {
    makeRequest,
    setBearerToken,
    bearerToken,
    setXAgency,
    createSessionRequest,
  }
}

export default useApi
